export default __webpack_public_path__ + "static/media/rain.bc9a4250.svg";